import React from 'react';
import { Route, Redirect, RouteProps, RouteComponentProps } from 'react-router-dom';
import { adminAuth } from '../helpers/api/adminApi';

interface AdminPrivateRouteProps extends RouteProps {
    component: React.ComponentType<any>;
    permission?: string;
}

const AdminPrivateRoute = ({ component: Component, permission, ...rest }: AdminPrivateRouteProps) => {
    return (
        <Route
            {...rest}
            render={(props: RouteComponentProps) => {
                if (!adminAuth.isAuthenticated()) {
                    return (
                        <Redirect
                            to={{
                                pathname: '/admin/login',
                                state: { from: props.location }
                            }}
                        />
                    );
                }

                const adminUser = adminAuth.getUser();

                if (permission && adminUser?.permissions) {
                    const isSuper = adminUser.permissions.includes('*') || adminUser.role_slug === 'super-admin';
                    if (!isSuper && !adminUser.permissions.includes(permission)) {
                        return (
                            <div className="container-fluid py-5 text-center">
                                <div className="card shadow-sm p-4 mx-auto" style={{ maxWidth: 500 }}>
                                    <h4 className="text-danger">Access Denied</h4>
                                    <p className="text-muted">You do not have permission ({permission}) to access this administrative module.</p>
                                    <button className="btn btn-outline-primary" onClick={() => window.history.back()}>
                                        Go Back
                                    </button>
                                </div>
                            </div>
                        );
                    }
                }

                return <Component {...props} />;
            }}
        />
    );
};

export default AdminPrivateRoute;
